var _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sw-js-blob-svg",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient",
    x1: 0,
    x2: 1,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop1",
    stopColor: "rgba(143.78, 178.763, 138.33, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop2",
    stopColor: "rgba(167.223, 255, 164.211, 1)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sw-gradient)",
    d: "M23,-28.6C28.6,-22.7,30.9,-14.3,32.4,-5.7C33.9,2.8,34.4,11.5,29.8,15.1C25.2,18.7,15.5,17.2,7.9,18.6C0.4,20,-5,24.2,-12.5,25.4C-19.9,26.5,-29.5,24.5,-33.8,18.7C-38,12.9,-36.9,3.3,-33.4,-4.1C-30,-11.5,-24.1,-16.7,-18.2,-22.4C-12.2,-28.2,-6.1,-34.6,1.3,-36.1C8.7,-37.7,17.4,-34.4,23,-28.6Z",
    width: "100%",
    height: "100%",
    transform: "translate(50 50)",
    strokeWidth: 0,
    style: {
      transition: "all 0.3s ease 0s"
    },
    stroke: "url(#sw-gradient)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBlob);
export default __webpack_public_path__ + "static/media/greenBlob.c3c93734b679984339c20200876568be.svg";
export { ForwardRef as ReactComponent };